import { CollaboratorButton } from './Button';
import { CollaboratorProvider } from './CollaboratorProvider';
import { CollaboratorSidebar } from './Sidebar';

export namespace Collaborator {
  export const Button = CollaboratorButton;
  export const Provider = CollaboratorProvider;
  export const Sidebar = CollaboratorSidebar;
}
